{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "重音符号和特殊字符",
  "account": "账户",
  "activity": "活动",
  "actor": "演员{{number}}",
  "actor_2": "角色 2",
  "actor_name": "演员姓名",
  "actor_voice": "演员声音",
  "add_alternatives": "添加替代选项",
  "add_another_reply": "添加另一个回复",
  "add_answer": "添加答案",
  "add_courses": "添加课程",
  "add_image": "添加图片",
  "add_image_desc": "为您的练习添加图片！",
  "add_link": "添加链接",
  "add_link_desc": "为您的练习添加链接！",
  "all_steps_complete": "所有步骤已完成",
  "alternative_versions": "其他版本",
  "archive_recording_error": "归档录音时出现问题",
  "assign": "分配",
  "attach_file": "附加文件",
  "bot_not_found": "未找到聊天机器人",
  "bot_not_found_desc": "找不到此聊天机器人。它可能已被删除或设为私密。",
  "categories": "分类",
  "chart": "图表",
  "choose_length_of_roleplay": "选择情景的长度",
  "clear": "清除",
  "close_pdf": "关闭 PDF",
  "comma_seperated_domains": "以逗号分隔的域名",
  "community": "社区",
  "datetime": "日期和时间",
  "days": "天",
  "days_late": "迟交 {{count}} 天",
  "discussion": "讨论",
  "download_error": "下载文件时出现问题",
  "editor_mode": "编辑模式",
  "email_notifications": "电子邮件通知",
  "enter_linguistic_goal": "输入语言学习目标",
  "add_new": "添加新内容",
  "add_phrase": "添加短语",
  "add_phrase_desc": "添加新的{{language}}短语供人们学习",
  "add_phrases": "添加短语",
  "add_phrases_to_enable_exercise": "添加短语以启用练习",
  "add_question": "添加问题",
  "add_question_desc": "提出一个理解题，问题可以有多个正确答案。答案的顺序就是它们在练习中出现的顺序。",
  "add_review": "添加评价",
  "add_review_desc": "在下面分享您的想法",
  "add_script": "添加脚本",
  "add_section": "添加部分",
  "add_substitution": "添加替换",
  "add_substitution_desc": "通过替换，您可以看到'what's'被扩展为'what is'—让您更好地控制如何回复用户的消息！",
  "add_topic": "添加主题",
  "add_topic_desc": "主题是触发器的逻辑分组。当用户处于某个主题中时，他们只能匹配属于该主题的触发器。",
  "add_topic_to_section": "将主题添加到{{sectionId}}部分",
  "add_trigger": "添加触发器",
  "add_trigger_desc": "触发器是用于匹配用户消息的文本行。",
  "add_variable": "添加变量",
  "add_variable_desc": "聊天机器人变量是描述您的聊天机器人的信息片段。通过聊天机器人变量，我们可以编写回复，让聊天机器人向用户介绍自己。",
  "add_voice": "添加声音",
  "all": "全部",
  "all_topics_completed": "所有主题已完成",
  "alternatives": "替代选项",
  "alternatives_desc": "可在您的聊天机器人中重复使用的单词或短语列表。",
  "alternatives_name": "名称",
  "alternatives_value": "单词列表（逗号分隔）",
  "answer": "答案",
  "new_answer_placeholder": "请在此输入您的答案",
  "answer_message_100": "完美，做得很好",
  "answer_message_90": "您正在进步，继续努力",
  "answer_message_95": "很接近了，您就快成功了",
  "answer_message_wrong": "那不太对",
  "answer_method": "答题方式",
  "answers": "答案",
  "attempt": "尝试",
  "attempt_info": "尝试信息",
  "attempt_messages": "练习尝试",
  "attempt_table": "尝试次数",
  "auto_translate": "允许学生将消息翻译成他们的母语",
  "auto_translate_phrase": "自动翻译短语",
  "auto_generate_phrase_translation": "生成翻译",
  "avg_pronunciation_score": "平均发音分数",
  "average_pronunciation_score_tooltip": "平均发音分数是",
  "B1": "B1",
  "B2": "B2",
  "back": "返回",
  "back_to_course": "返回课程",
  "blog": "博客",
  "bot": "聊天机器人",
  "bot-listen-and-speak": "聊天机器人 - 听与说",
  "all_modes": "所有模式",
  "bot_information": "聊天机器人信息",
  "bot_intro_message": "聊天机器人介绍消息",
  "bot_intro_message_helper_text": "如果您希望学生开始对话，请留空。",
  "bot_name": "聊天机器人名称",
  "bot_outputs": "聊天机器人输出",
  "bot_reply": "聊天机器人回复",
  "bot_settings": "聊天机器人设置",
  "bot_title": "聊天机器人标题",
  "bot_voice": "聊天机器人声音",
  "bots": "聊天机器人",
  "bots_not_found_desc": "今天创建第一个聊天机器人",
  "bots_not_found_title": "未找到机器人",
  "C1": "C1",
  "C2": "C2",
  "cancel": "取消",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "更改应用程序颜色",
  "change_language": "更改语言",
  "chatbot_exercise_desc": "通过引导性提示练习对话。",
  "chatbots": "聊天机器人",
  "choose_avatar": "选择努阿拉",
  "choose_from_file": "从文件中选择",
  "classroom_code": "教室代码",
  "classroom_code_label": "输入教室代码",
  "classroom_code_not_valid": "教室代码无效",
  "classroom_created": "教室已创建",
  "classroom_deleted": "教室已删除",
  "classroom_information": "教室信息",
  "classroom_name": "教室名称",
  "classroom_not_found": "未找到教室",
  "classroom_not_found_desc": "此教室可能已被删除",
  "classroom_load_error": "无法加载教室",
  "classroom_load_error_desc": "加载此教室时出错。请重试。",
  "classroom_settings": "教室设置",
  "classrooms": "教室",
  "classrooms_not_found_desc": "今天创建第一个教室",
  "classrooms_not_found_title": "未找到教室",
  "collaborators": "协作者（可选）",
  "color": "颜色",
  "community_templates": "社区模板",
  "completed": "已完成",
  "completed_icon": "完成图标",
  "completion": "完成",
  "completions": "完成次数",
  "confirmation": "确认",
  "contact_form": "联系我们",
  "continue": "继续",
  "continue_exercise": "继续练习",
  "continue_learning": "继续学习",
  "continue_teaching": "继续教学",
  "copied": "已复制",
  "copy_to_clipboard": "复制到剪贴板",
  "correct": "正确",
  "correct_answer": "正确答案",
  "correct_answer_percentage": "正确答案百分比",
  "course": "课程",
  "course_code": "课程代码",
  "course_code_label": "输入课程代码",
  "course_code_not_valid": "课程代码无效",
  "course_created": "课程已创建",
  "course_deleted": "课程已删除",
  "course_information": "课程信息",
  "course_name": "课程名称",
  "course_not_found": "未找到课程",
  "course_not_found_desc": "此课程可能已被删除",
  "course_outline": "课程大纲",
  "course_progress": "课程进度",
  "course_settings": "课程设置",
  "courses": "课程",
  "courses_not_found_desc": "今天创建第一个课程",
  "courses_not_found_title": "未找到课程",
  "create": "创建",
  "create_bot": "创建聊天机器人",
  "create_classroom": "创建教室",
  "create_course": "创建课程",
  "create_course_section": "创建课程部分",
  "create_course_section_desc": "由您决定如何构建课程，示例结构如'初级，中级，高级'或'第1周，第2周，第3周'",
  "create_duplicate": "创建副本",
  "create_topic": "创建主题",
  "created_courses": "已创建的课程",
  "creation_visibility": "公开内容可作为其他教育者创作的起点。",
  "creator": "创建者",
  "creator_instructions": "教师说明",
  "creator_instructions_placeholder": "您可以在这里为课程协作者添加格式化的指导消息\\n\\n例如\"欢迎使用聊天机器人，这是您如何为学生自定义此聊天机器人的方法...\"",
  "customization": "自定义",
  "dark_theme": "深色主题",
  "dark_theme_desc": "将页面的浅色表面变成深色，创造适合夜晚的体验。",
  "date": "日期",
  "delete_bot": "删除聊天机器人",
  "delete_bot_confirmation": "您确定要删除此聊天机器人吗？",
  "delete_classroom": "删除教室",
  "delete_classroom_confirmation": "您确定要删除此教室吗？",
  "delete_course": "删除课程",
  "delete_course_confirmation": "您确定要删除此课程吗？",
  "delete_phrase": "删除短语",
  "delete_phrase_confirmation": "您确定要删除此短语吗？",
  "delete_picture": "删除图片",
  "delete_review": "删除评价",
  "delete_review_confirmation": "您确定要删除您的评价吗？",
  "delete_roleplay": "删除情景",
  "delete_roleplay_confirmation": "您确定要删除此情景吗？",
  "delete_section": "删除部分",
  "delete_section_confirmation": "您确定要删除此部分吗？",
  "delete_topic": "删除主题",
  "delete_topic_confirmation": "您确定要删除此主题吗？",
  "description": "描述",
  "difficulty": "难度",
  "difficulties": "难度",
  "disable": "禁用",
  "disabled": "已禁用",
  "display": "显示",
  "display_classroom_code": "显示教室代码",
  "download_csv_file": "下载",
  "drop_csv_file_or_click_to_upload": "拖放CSV文件或点击上传。",
  "edit": "编辑",
  "edit_bot": "编辑聊天机器人",
  "edit_discussion": "编辑讨论",
  "edit_roleplay": "编辑情景",
  "email": "邮箱",
  "enable": "启用",
  "enabled": "已启用",
  "enrolment_key": "注册密钥",
  "enrolment_key_not_valid": "注册密钥无效",
  "enter_private_key": "输入注册密钥",
  "error_generating_discussion": "生成讨论时出现问题",
  "exercise": "练习",
  "exercise_complete": "练习完成",
  "exercise_completed_icon": "{{name}} 已完成 {{counter}} 次",
  "exercise_completion": "完成了{{exercise}}练习'{{id}}'",
  "exercise_in_progress": "开始了{{exercise}}练习'{{id}}'",
  "exercise_info": "练习信息",
  "exercise_no_longer_available": "此练习不再可用",
  "exercises": "练习",
  "exercises_completed": "练习已完成",
  "exercise_progress_bar": "练习进度条",
  "exercises_completed_icon": "{{name}} 已完成 {{counter}} 次",
  "exit": "退出",
  "expand": "展开",
  "fill_in_contact_form": "请填写下面的表格",
  "find_bot": "查找聊天机器人",
  "find_classroom": "查找教室",
  "find_course": "查找课程",
  "find_roleplay": "查找情景",
  "finish": "完成",
  "finish_exercise": "完成练习",
  "for_lang": "我说",
  "formatting_options": "格式选项",
  "fri": "周五",
  "from": "从",
  "fullscreen": "全屏",
  "generate_definitions_info": "为此列表中的短语生成释义。",
  "generating": "生成中",
  "get_started": "开始",
  "go_back": "返回",
  "go_back_to_topic": "返回主题",
  "go_to": "前往",
  "go_to_settings": "前往设置",
  "group_information_form_title": "介绍一下您的小组",
  "group_member_limit": "小组成员上限",
  "group_name": "小组名称",
  "group_picture": "小组图片",
  "group_subscription_form_title": "设置小组订阅",
  "help": "帮助",
  "hidden": "已隐藏",
  "hide": "隐藏",
  "hide_bot": "隐藏聊天机器人",
  "hide_chatbots_exercise": "隐藏机器人",
  "hide_listening_exercise": "隐藏听力练习",
  "hide_menu": "隐藏菜单",
  "hide_options": "隐藏选项",
  "hide_pronunciation_exercise": "隐藏发音练习",
  "hide_roleplay": "隐藏情景",
  "hide_roleplays_exercise": "隐藏情景",
  "hide_section": "隐藏部分",
  "hide_topic": "隐藏主题",
  "hide_translation_exercise": "隐藏翻译练习",
  "hide_word_bank": "隐藏单词库",
  "hide_from_students": "对学生隐藏",
  "home": "首页",
  "how_to_join_find_button": "找到 {{button}} 按钮并点击。",
  "how_to_join_get_ready": "准备开始游戏。",
  "how_to_join_intro": "要加入游戏，请按以下步骤操作：",
  "how_to_join_open_classroom": "打开班级 {{classroom}} 或扫描下方的二维码",
  "how_to_join_sign_in": "登录您的账户。",
  "how_to_join_title": "如何加入游戏",
  "in_game": "游戏中",
  "in_progress": "继续游戏",
  "incorrect": "错误",
  "insert_bold": "插入粗体",
  "insert_italic": "插入斜体",
  "insert_link": "插入链接",
  "insert_photo": "插入图片",
  "instruction_message": "说明",
  "interculturarity": "跨文化理解",
  "join": "加入",
  "join_classroom": "加入教室",
  "join_code_desc": "学生可以使用下面的代码加入",
  "join_course": "加入课程",
  "join_date": "加入日期",
  "joined": "已加入",
  "joined_classroom": "已加入教室",
  "joined_course": "已加入课程",
  "language": "语言",
  "language_phrase": "{{language}}短语",
  "language_translation": "{{language}}翻译",
  "learn": "学习",
  "learn_for_speakers_of": "{{forLang}}使用者学习{{learnLang}}",
  "learn_lang": "我想要学习",
  "loading": "加载中",
  "loading_topics": "正在加载主题",
  "meaning-listen-and-speak": "意思 - 听与说",
  "meaning-read-and-write": "意思 - 读与写",
  "meaning_listen_and_speak_exercise_desc": "听释义并说出对应的短语。",
  "more_definitions": "更多释义",
  "more_translations": "更多翻译",
  "new": "新",
  "no_archived_discussions": "没有已归档的讨论",
  "no_chatbot_templates": "没有可用的模板",
  "no_discussions": "没有讨论",
  "no_discussions_description": "讨论是让学生通过协作对话参与学习的好方法。创建讨论可以练习口语、增强自信并培养沟通能力。",
  "no_past_due_assignments": "没有逾期的作业",
  "no_past_due_discussions": "没有逾期的讨论",
  "no_phrases": "没有短语",
  "no_scheduled_assignments": "没有已安排的作业",
  "no_topics_available": "没有可用的主题",
  "not_in_game": "未加入",
  "nudge_add_family_name_field_desc": "添加您的姓氏，方便老师识别您。",
  "nudge_add_family_name_profile_desc": "在个人资料中添加您的姓氏，方便老师识别您。",
  "nudge_add_family_name_title": "添加您的姓氏",
  "on": "于",
  "open_image_library": "打开图片库",
  "perfect_click_finish_create_group": "很好！点击“完成”创建您的小组。",
  "phrase_definition": "短语释义",
  "phrase_definition_helper_text": "按 Enter 键添加释义。",
  "phrase_group_game_in_progress_icon": "{{name}} 进行中",
  "phrase_lists_error": "加载短语列表时出现问题",
  "player": "位玩家",
  "players": "位玩家",
  "please_select_a_textfield": "请选择一个文本框",
  "preview_pdf": "预览 PDF",
  "print": "打印",
  "questions": "问题",
  "recommended": "推荐",
  "record_unsupported": "此浏览器不支持录音",
  "refresh": "刷新",
  "result": "结果",
  "retry": "重试",
  "roleplay_not_found": "未找到情景",
  "roleplay_not_found_desc": "找不到此情景。它可能已被删除或设为私密。",
  "save_definitions_error": "保存释义时出现问题",
  "scenarios": "情景",
  "schedule": "安排",
  "script_not_found": "未找到脚本",
  "script_not_found_desc": "找不到此脚本。它可能已被删除或设为私密。",
  "search_images": "搜索图片",
  "see_more_pronunciations": "查看更多发音",
  "send": "发送",
  "show_phrase_list": "显示短语列表",
  "student_limit": "学生人数上限",
  "submit": "提交",
  "submitting": "提交中",
  "subscription": "订阅",
  "subscription_period_end": "订阅期结束",
  "subscription_status": "订阅状态",
  "table": "表格",
  "teach": "教学",
  "leave_classroom": "离开教室",
  "leave_classroom_confirmation": "您确定要离开此教室吗？",
  "leave_course": "离开课程",
  "leave_course_confirmation": "您确定要离开此课程吗？",
  "left_classroom": "已离开教室",
  "left_course": "已离开课程",
  "lets_begin": "让我们开始",
  "library": "图书馆",
  "link_name": "链接名称",
  "link_name_helper_text": "为您的链接输入显示名称",
  "link_value": "链接地址",
  "link_value_helper_text": "输入您的链接网址",
  "listen_to_this_phrase": "听这个{{language}}短语",
  "listener": "听者",
  "listener_dialog_desc": "选择下面的声音来听发音",
  "listening": "听力",
  "listening_exercise_desc": "听并识别您听到的短语。",
  "load_more_events": "加载更多事件",
  "logout": "退出登录",
  "manage_course": "管理课程",
  "members": "学生",
  "members_not_found": "没有学生",
  "members_not_found_desc": "未找到学生",
  "message": "消息",
  "method": "方法",
  "missing_details": "缺少详细信息",
  "mon": "周一",
  "more_options": "更多选项",
  "my_courses": "我的课程",
  "name": "名称",
  "new_bots": "新聊天机器人",
  "new_courses": "新课程",
  "new_roleplays": "新情景",
  "next": "下一个",
  "next_with_progress": "下一个 ({current}/{total})",
  "no_activity_found": "未找到活动",
  "no_courses_found": "未找到课程",
  "no_results_found": "未找到结果",
  "nualang_templates": "模板",
  "only_available_on_chrome": "仅在Chrome上可用",
  "open_in_google_sheets": "在Google Sheets中打开",
  "open_search_student_name_filters": "打开搜索学生姓名筛选器",
  "option": "选项",
  "optional": "可选",
  "or_choose_from_one_of_the_following": "或从以下选项中选择",
  "percentage_complete": "完成百分比",
  "phrase": "短语",
  "phrases": "短语",
  "play_again": "再次游戏",
  "plays": "{{number}}次游戏",
  "popular_courses": "热门课程",
  "preview": "预览",
  "previous": "上一个",
  "private": "私人的",
  "problem": "出现了问题",
  "problem_creating": "创建时出现问题",
  "problem_deleting": "删除时出现问题",
  "problem_getting_reply": "获取回复时出现问题",
  "problem_loading": "加载时出现问题",
  "problem_sending_contact_form": "发送联系表单时出现问题",
  "profile": "个人资料",
  "profiles": "个人资料",
  "progress_icon": "进度图标",
  "pronounce_this_phrase": "发音这个短语",
  "pronunciation": "发音",
  "pronunciation_exercise_desc": "练习自然清晰地说短语。",
  "public": "公开的",
  "question": "问题",
  "new_question_placeholder": "请在此输入您的问题",
  "quit": "退出",
  "record_message": "录制消息",
  "records": "记录",
  "redo_action": "重做",
  "remove": "移除",
  "remove_card": "移除卡片",
  "remove_bot": "移除聊天机器人",
  "remove_roleplay": "移除情景",
  "remove_classroom_member": "移除教室学生",
  "remove_classroom_member_confirmation": "您确定要从教室中移除此学生吗",
  "remove_member": "移除学生",
  "member_removed_from_classroom": "学生已从教室中移除",
  "reply": "回复",
  "reply_options": "回复选项",
  "reply_options_are_disabled": "回复选项已禁用",
  "reply_options_desc": "允许学生从选项列表中选择正确的回复",
  "report_views": "浏览次数",
  "required_for_private_classrooms": "私人教室必需",
  "required_for_private_courses": "私人课程必需",
  "reset": "重置",
  "restart_exercise": "重新开始练习",
  "return_to_course": "返回课程",
  "review_content": "评价内容",
  "review_title": "评价标题",
  "reviews": "评价",
  "reviews_not_found": "没有评价",
  "reviews_not_found_desc": "未找到评价",
  "role_played": "扮演角色",
  "roleplay": "情景",
  "roleplay_exercise_desc": "进入场景并通过对话练习。",
  "roleplays_not_found_desc": "今天创建第一个情景",
  "roleplay_information": "情景信息",
  "roleplay_name": "情景名称",
  "roleplay_settings": "情景设置",
  "roleplays": "情景",
  "sat": "周六",
  "save_changes": "保存更改",
  "save_progress": "保存进度",
  "show_progress": "显示进度",
  "script": "脚本",
  "search": "搜索",
  "search_for_student": "搜索学生",
  "section": "部分",
  "section_name": "部分名称",
  "section_visibility": "部分可见性",
  "sections_not_found": "未找到部分",
  "sections_not_found_desc": "",
  "select_a_template": "选择模板",
  "select_file": "选择文件",
  "select_file_desc": "将文件拖放到这里或点击浏览您的计算机",
  "select_files": "选择文件",
  "select_the_from_date": "选择开始日期",
  "select_the_to_date": "选择结束日期",
  "settings": "设置",
  "share": "分享",
  "share_via": "通过以下方式分享",
  "show_bot": "显示聊天机器人",
  "show_chatbots_exercise": "显示机器人",
  "show_listening_exercise": "显示听力练习",
  "show_menu": "显示菜单",
  "show_options": "显示选项",
  "show_pronunciation_exercise": "显示发音练习",
  "show_roleplay": "显示情景",
  "show_roleplays_exercise": "显示情景",
  "show_section": "显示部分",
  "show_topic": "显示主题",
  "show_translation_exercise": "显示翻译练习",
  "show_word_bank": "显示单词库",
  "show_to_students": "向学生显示",
  "skip": "跳过",
  "skip_copy_topic": "跳过",
  "skipped": "已跳过",
  "speak": "说话",
  "speakers_of": "使用者",
  "start": "开始",
  "start_course": "开始课程",
  "stop": "停止",
  "stop_recording": "停止录制",
  "student_instructions": "学生说明",
  "student_instructions_placeholder": "学生说明：\\n您可以在这里添加格式化的说明消息\\n\\n例如\\\"欢迎使用聊天机器人，您可以通过输入hello开始\\\"",
  "subject": "主题",
  "substitution_desc": "在检查触发器之前对用户消息进行更改。",
  "substitution_name": "原始文本",
  "substitution_name_helper_text": "可能出现在用户消息中的原始文本",
  "substitution_value": "替换文本",
  "substitution_value_helper_text": "不应包含任何特殊符号或标点符号，并且应该是小写的",
  "substitutions": "替换",
  "sun": "周日",
  "text": "文本",
  "thank_you_for_submitting": "感谢您的提交，我们会尽快与您联系。",
  "the_default_topic_is_random": "默认主题是随机的",
  "thu": "周四",
  "time": "时间",
  "time_spent": "花费时间",
  "to": "到",
  "toggle_theme": "切换明/暗主题",
  "toggle_light": "切换亮色主题",
  "toggle_dark": "切换深色主题",
  "topic": "主题",
  "topic_code": "主题代码",
  "topic_desc": "当用户处于某个主题中时，他们只能匹配属于该主题的触发器。",
  "topic_image": "主题图片",
  "topic_information": "主题信息",
  "topic_settings": "主题设置",
  "topic_title": "主题标题",
  "topic_name": "主题名称",
  "topic_not_found": "未找到主题",
  "topic_not_found_desc": "此主题可能已被删除",
  "topics": "主题",
  "translate": "翻译",
  "translate_is_disabled": "翻译已禁用",
  "translate_this_phrase": "翻译这个短语",
  "translation": "翻译",
  "translation_exercise_desc": "检查您对关键短语的理解。",
  "translations": "翻译",
  "trigger_value": "触发器文本",
  "trigger_value_helper_text": "不应包含任何特殊符号或标点符号，并且应该是小写的",
  "triggers": "触发器",
  "triggers_desc": "触发器是用于匹配用户消息的文本行。",
  "tue": "周二",
  "type": "类型",
  "unarchive": "取消归档",
  "undo_action": "撤销",
  "update": "更新",
  "update_image": "更新图片",
  "update_link": "更新链接",
  "update_phrase": "更新短语",
  "update_phrase_desc": "对现有短语进行更改",
  "update_picture": "更新图片",
  "update_question": "更新问题",
  "update_question_desc": "提出一个理解题，问题可以有多个正确答案。答案的顺序就是它们在练习中出现的顺序。",
  "update_recording_error": "更新录音时出现问题",
  "update_review": "更新评价",
  "update_review_desc": "更新评价描述",
  "update_section": "更新部分",
  "update_section_desc": "由您决定如何构建课程，示例结构如'初级，中级，高级'或'第1周，第2周，第3周'",
  "update_substitution": "更新替换",
  "update_topic": "更新主题",
  "update_trigger": "更新触发器",
  "update_variable": "更新变量",
  "upgrade": "升级",
  "upload_phrases": "上传短语",
  "upload_phrases_desc": "创建并上传如下面示例的csv文件。",
  "upload_phrases_example_phrase_1": "你好",
  "upload_phrases_example_phrase_2": "再见",
  "upload_phrases_example_phrase_3": "我叫",
  "upload_phrases_example_definition_1": "用于打招呼的词",
  "upload_phrases_example_definition_2": "用于告别的词",
  "upload_phrases_example_definition_3": "用于告诉别人你名字的短语",
  "upload_script": "上传脚本",
  "upload_script_desc": "使用如下所示格式通过csv文件上传情景脚本",
  "use_keyboard": "使用键盘",
  "use_word_bank": "使用单词库",
  "user_message": "用户消息",
  "user_updated": "用户已更新",
  "variable_desc": "可在您的聊天机器人中使用的信息片段。",
  "variable_name": "变量名称",
  "variable_value": "变量值",
  "variables": "变量",
  "vars": "变量",
  "view_activity": "查看活动",
  "view_instruction_message": "查看说明",
  "view_outline": "查看大纲",
  "view_progress": "查看进度",
  "view_report": "查看报告",
  "visibility": "可见性",
  "visit_learning_site": "访问 Learning Site",
  "voice": "声音",
  "voice_speed_disabled": "此语音不支持调整语速",
  "wed": "周三",
  "weekly_progress": "每周进度",
  "what_do_you_hear": "您听到什么？",
  "word_bank": "单词库",
  "active_now": "现在活跃",
  "choose_a_language": "选择语言",
  "manage_classroom": "管理教室",
  "must_question_least_correct_answer": "必须是一个问题且至少有一个正确答案。",
  "enter_name_your_voice_clip": "为您的语音片段输入名称？",
  "my_unnamed_clip": "我的未命名片段",
  "are_you_sure": "您确定吗？",
  "is_already_created_variable_overwrite": "已经是一个创建的变量，您要覆盖它吗？",
  "is_already_created_substitution_overwrite": "已经是一个创建的替换，您要覆盖它吗？",
  "is_already_created_alternative_overwrite": "已经是一个创建的替代，您要覆盖它吗？",
  "is_already_created_topic_overwrite": "已经是一个创建的主题，您要覆盖它吗？",
  "bring_your_bot_picture_name": "通过给聊天机器人添加图片和名称来让它变得生动",
  "perfect_click_finish_create_bot": "完美，点击完成创建您的新聊天机器人",
  "lets_start_with_some_information_about_your_bot": "让我们从一些关于您的聊天机器人的信息开始",
  "lets_start_some_information_about_classroom": "让我们从一些关于您的教室的信息开始",
  "the_language_classroom_teach": "此教室将教授的语言",
  "the_language_students_classroom_speak": "此教室学生说的语言",
  "limit_access_classroom_visibility_private_including_enrolment_key": "通过将可见性设置为私人并包含注册密钥来限制对教室的访问",
  "add_collaborators": "添加协作者",
  "perfect_click_finish_create_classroom": "完美，点击完成创建您的新教室",
  "perfect_click_finish_create_course": "完美，点击完成创建您的新课程",
  "lets_start_information_about_course": "让我们从一些关于您的课程的信息开始",
  "the_language_course_teach": "此课程将教授的语言",
  "the_language_students_course_speak": "此课程学生说的语言",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "通过将可见性设置为私人并包含注册密钥来限制对课程的访问",
  "selected": "已选择",
  "perfect_click_finish_create_roleplay": "完美，点击完成创建您的新情景",
  "lets_start_with_information_about_roleplay": "让我们从一些关于您的情景的信息开始",
  "play_bot": "玩聊天机器人",
  "invite": "邀请",
  "unanswered_table": "未回答",
  "create_roleplay": "创建情景",
  "roleplays_not_found_title": "未找到情景",
  "play": "游戏",
  "delete": "删除",
  "use_wordbank_if_stuck": "如果需要帮助请使用单词库",
  "play_bot_error": "哎呀！聊天机器人出现问题，请重试",
  "bot_editor_preview_error": "发生了错误。请参考屏幕顶部的帮助弹出窗口（问号图标）。",
  "lets_find_a_template": "让我们找一个模板！",
  "search_by_difficulty": "按难度搜索",
  "search_using_keywords": "使用关键词搜索",
  "select_a_nualang_template": "选择努阿朗模板",
  "select_a_nualang_template_desc": "由努阿朗团队构建的模板，帮助您入门。",
  "or_select_a_community_template": "或选择社区模板",
  "or_select_a_community_template_desc": "社区模板由世界各地的教师构建。",
  "dashboard_welcome": "欢迎，{{name}}！",
  "dashboard_welcome_desc": "熟悉探索页面，这里有一些入门方法。",
  "enter_course_code": "输入课程代码",
  "enter_course_code_desc": "如果您有课程代码，请在此处输入。",
  "enter_classroom_code": "输入教室代码",
  "enter_classroom_code_desc": "如果您有教室代码，请在此处输入。",
  "search_nualang": "探索努阿朗",
  "search_nualang_desc": "有越来越多志同道合的教师使用我们的努阿拉开发对话，因此总有新的东西可以学习。",
  "create_nualang": "创建您自己的",
  "create_nualang_desc": "创建对话和语言课程。",
  "roleplay_editor_welcome": "情景编辑器入门",
  "roleplay_editor_options": "选择选项",
  "roleplay_editor_options_desc": "选择努阿拉添加新行，或添加理解题。",
  "roleplay_editor_share": "分享情景",
  "roleplay_editor_play": "游戏情景",
  "bot_editor_welcome": "聊天机器人编辑器入门",
  "bot_editor_sidebar": "编辑器侧边栏",
  "bot_editor_sidebar_desc": "侧边栏是您可以对聊天机器人进行更改的地方。",
  "bot_editor_flow_chart": "聊天机器人流程",
  "bot_editor_flow_chart_desc": "聊天机器人流程显示您的聊天机器人概览并预览每条消息的外观。",
  "bot_editor_share": "分享聊天机器人",
  "bot_editor_play": "玩聊天机器人",
  "play_roleplay": "玩情景",
  "customize_appearance_of_course": "自定义课程外观",
  "customize_appearance_of_classroom": "自定义教室外观",
  "customize_appearance_of_topic": "自定义主题外观",
  "manage_courses": "管理课程",
  "refresh_courses": "刷新课程",
  "delete_script_item": "从脚本中删除项目",
  "delete_script_item_confirmation": "您确定要从脚本中删除此项目吗？",
  "add_message": "添加消息",
  "resources": "资源",
  "contact": "联系",
  "sign_in": "登录",
  "sign_up": "注册",
  "faqs": "常见问题",
  "guides": "指南",
  "back_to_app": "返回应用程序",
  "notes": "笔记",
  "notes_placeholder": "在此处输入笔记",
  "get_in_touch": "联系我们",
  "get_in_touch_desc": "有问题或反馈？给我们发消息。",
  "avatar_generator": "头像生成器",
  "avatar_generator_desc": "制作您自己的个人头像",
  "upload_image": "上传图片",
  "upload_image_desc": "从您的计算机拖放图片",
  "random": "随机",
  "done": "完成",
  "file_size_exceeded": "图片太大！请上传小于以下大小的图片",
  "image_selection_failed": "无法加载该图片。请尝试其他图片或上传您自己的图片。",
  "remove_course": "移除课程",
  "courses_joined": "已加入的课程",
  "courses_added": "课程已添加",
  "problem_adding_courses": "添加这些课程时出现问题",
  "classroom_courses_not_found_title": "还没有课程",
  "classroom_courses_not_found_desc": "此教室还没有任何课程。",
  "in_progress_activity": "进行中",
  "bot_exercise_welcome": "聊天机器人练习入门",
  "bot_exercise_restart": "重新启动聊天机器人！",
  "bot_exercise_keyboard_input": "输入它！",
  "bot_exercise_keyboard_input_desc": "使用键盘输入消息。如果您需要特殊字符的帮助或想添加表情符号，请尝试我们的有用按钮。",
  "bot_exercise_voice_input": "说出来！",
  "bot_exercise_voice_input_desc": "点击麦克风使用您的声音练习发音。",
  "bot_exercise_send_message": "发送它！",
  "bot_exercise_send_message_desc": "向聊天机器人发送消息并开始对话。",
  "bot_exercise_audio_only_mic": "说出来！",
  "bot_exercise_audio_only_mic_desc": "点击麦克风开始。之后只需自然地说话——Nuala会自动倾听并回应对话的其余部分。",
  "roleplay_exercise_welcome": "情景练习入门",
  "roleplay_exercise_read_script": "学习您的台词！",
  "roleplay_exercise_read_script_desc": "阅读对话并听单词的发音。",
  "roleplay_exercise_select_an_actor": "选择您的角色！",
  "roleplay_exercise_select_an_actor_desc": "选择您想要扮演的角色。",
  "roleplay_exercise_start": "表演出来！",
  "roleplay_exercise_start_desc": "点击开始，使用键盘或声音来表演您选择的角色。",
  "listening_exercise_welcome": "听力练习入门",
  "listening_exercise_speak": "听短语！",
  "listening_exercise_speak_desc": "点击听短语的发音。",
  "listening_exercise_voice_options": "听不同的声音！",
  "listening_exercise_voice_options_desc": "听用不同声音说的短语。",
  "listening_exercise_keyboard_input": "输入答案！",
  "listening_exercise_keyboard_input_desc": "使用键盘输入您听到的短语。",
  "listening_exercise_word_bank": "需要帮助？",
  "listening_exercise_word_bank_desc": "使用单词库选择正确答案。",
  "translation_exercise_welcome": "翻译练习入门",
  "translation_exercise_speak": "听短语！",
  "translation_exercise_speak_desc": "点击听短语的发音。",
  "translation_exercise_read": "阅读短语！",
  "translation_exercise_read_desc": "阅读要翻译的短语。",
  "translation_exercise_keyboard_input": "输入答案！",
  "translation_exercise_keyboard_input_desc": "使用键盘输入翻译。",
  "translation_exercise_word_bank": "需要帮助？",
  "translation_exercise_word_bank_desc": "使用单词库选择正确答案。",
  "pronunciation_exercise_welcome": "发音练习入门",
  "pronunciation_exercise_speak": "听短语！",
  "pronunciation_exercise_speak_desc": "点击听短语的发音。",
  "pronunciation_exercise_read": "阅读短语！",
  "pronunciation_exercise_read_desc": "阅读要发音的短语。",
  "pronunciation_exercise_voice_input": "发音短语！",
  "pronunciation_exercise_voice_input_desc": "点击麦克风使用您的声音练习发音。",
  "exercise_share": "与他人分享！",
  "exercise_mute": "静音！",
  "exercise_skip": "跳过！",
  "exercise_skip_desc": "移动到下一个短语，您将能够在结尾时再次尝试。",
  "exercise_restart": "重新开始！",
  "what_would_you_like_to_do": "您想做什么？",
  "i_want_to_learn": "我想学习...",
  "i_want_to_teach": "我想教学...",
  "add_alternative_version": "添加替代版本",
  "add_alternative_version_explanation": "添加短语的替代版本以标记为正确，例如'You are welcome'可能是'You're welcome'的替代",
  "language_translation_helper_text": "按回车键添加翻译。",
  "change_roles": "更改角色？",
  "write_your_feedback_here": "在此填写您的反馈",
  "yes": "是",
  "you_are_human": "如果您是真人，请将此栏留空",
  "you_are_human_check": "请确认您不是机器人",
  "you_will_lose_your_progress_on_this_exercise": "您将丢失此练习的进度。",
  "confirm": "确认",
  "general": "一般",
  "shuffle_phrases": "打乱短语",
  "shuffle_phrases_desc": "随机化练习中提问题的顺序。",
  "errors": "错误",
  "missing_translation": "缺少翻译",
  "missing_phrase": "缺少短语",
  "invalid_image_domain": "图片URL必须来自经批准的Nualang域名",
  "row": "行",
  "no_valid_type": "类型必须是'actor'或'question'",
  "no_actor_text": "演员没有文本",
  "no_actor_number": "演员必须在末尾有数字，例如actor1, actor2",
  "no_question": "没有问题",
  "no_answers_provided": "没有提供答案",
  "no_correct_answer_provided": "没有提供正确答案",
  "no_answers": "没有答案",
  "duplicate_topic": "重复主题",
  "normal_mode": "普通模式",
  "spreadsheet_mode": "电子表格模式",
  "image": "图片",
  "delete_selected_row": "删除选定行",
  "crop_image": "裁剪图片",
  "crop": "裁剪",
  "zoom": "缩放",
  "rotate": "旋转",
  "hide_preview": "隐藏预览",
  "show_preview": "显示预览",
  "try_again": "再试一次",
  "subscription_plan_teach": "教学计划",
  "subscription_plan_teacher_pro": "教师专业版",
  "subscription_plan_basic": "教师基础版",
  "subscription_plan": "订阅计划",
  "subscription_status_trialing": "免费试用",
  "subscription_status_active": "活跃",
  "subscription_status_canceled": "已取消",
  "subscription_status_undefined": "免费",
  "status": "状态",
  "upgrade_plan": "升级计划",
  "manage_plan": "管理计划",
  "cancel_plan": "取消计划",
  "your_plan": "您的计划",
  "plan_cost": "计划费用",
  "next_billing_date": "当前周期结束",
  "free": "免费",
  "payment_method": "付款方式",
  "confidence_score": "置信度百分比表示单个单词被正确识别的概率。",
  "first_name": "名",
  "last_name": "姓",
  "role": "角色",
  "school_name": "学校名称",
  "school_district": "学区",
  "city": "城市",
  "state": "州",
  "send_message": "发送消息",
  "pricing_page_title": "选择您的计划",
  "pricing_page_subtitle": "面向教师、学校和学区的定价计划。",
  "pricing_page_testimonials_title": "教师们怎么说",
  "compare_plans": "比较计划",
  "features": "功能",
  "upgrade_submit": "升级",
  "upgrade_subscription_desc": "要访问此功能，您需要升级您的账户。点击升级进入定价页面。",
  "upgrade_plan_explanation": "要访问此功能，您需要升级您的账户。",
  "upgrade_subscription_student": "此功能仅适用于教师。",
  "public_visibility_disabled_wayside": "课堂由 Wayside Publishing 管理，必须保持私密。",
  "public_visibility_disabled_loading": "我们仍在检查您的订阅。如果没有更新，请刷新页面。",
  "public_visibility_disabled_trial": "免费试用期间无法使用公开课堂。升级到付费计划即可将此课堂设为公开。",
  "creator_not_subscribed": "此内容无法加入，因为创建者当前没有订阅。",
  "sign_me_up": "为我注册！",
  "free_trial": "免费试用",
  "interactive_demo": "获取演示",
  "news_and_updates": "新闻和更新",
  "teacher": "教师",
  "principal": "校长",
  "tutor": "家教",
  "parent": "家长",
  "student": "学生",
  "other": "其他",
  "none": "无",
  "group_subscription_plans": "团体订阅计划",
  "group_plan": "团体计划",
  "leave_group": "离开团体",
  "joined_subscription": "已加入订阅",
  "joined_subscription_desc": "欢迎加入{{groupName}}团体订阅，您现在正在使用教师专业版！",
  "unable_to_join_subscription": "无法加入订阅",
  "unable_to_join_subscription_desc": "加入订阅时出现问题，请稍后重试。",
  "unable_to_join_subscription_invalid_email_desc": "您无法在没有允许的电子邮件域名的情况下加入此团体：{{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}'已达到学生限制，请联系团体管理员增加限制。",
  "moderated_image_dialog": "努阿朗检测到不合适、不需要或令人反感的图片并阻止了它，以提供更安全的用户体验。请尝试其他图片。",
  "moderate_title": "图片已阻止",
  "recommended_courses": "推荐课程",
  "subscription_status_trialing_expired": "免费试用已过期",
  "no_public_content_created": "未创建公开内容",
  "content_tags": "添加标签",
  "enter_info_tags": "在下面输入逗号分隔的标签列表。",
  "add_tag": "按回车键添加标签",
  "enter_collaborator_email": "在下面输入逗号或空格分隔的电子邮件地址列表。协作者可以管理课程、学生和教室设置。",
  "add_collaborator_tag": "按回车键添加协作者",
  "add_to_classroom": "添加到教室",
  "add_to_classroom_desc": "将'{{courseName}}'添加到{{classroomNames}}。",
  "change_voice_speed": "更改语音速度！",
  "extra_fast": "超快速度",
  "fast": "说话很快",
  "medium": "正常速度",
  "slow": "慢一点",
  "extra_slow": "一次一个字",
  "card_ALL": "全部",
  "join_classroom_to_access": "加入教室以访问",
  "join_course_to_access": "加入课程以访问",
  "confidence": "置信度",
  "teach_lang": "我想要教",
  "write_feedback": "写反馈",
  "allowed_domains": "允许的学校域名（可选）",
  "enter_domains_info": "在下面输入逗号或空格分隔的学校域名列表。",
  "add_allowed_domains_desc": "基于学校域名限制访问，例如'schooldomain.com'",
  "send_feedback": "发送反馈",
  "add_feedback": "添加反馈",
  "feedback_content": "反馈内容",
  "report_problem": "报告问题",
  "report_problem_input_label": "问题描述",
  "update_feedback": "更新反馈",
  "student_completes_exercise": "学生完成练习",
  "delete_feedback_confirmation": "您确定要删除此反馈吗？",
  "delete_feedback": "删除反馈",
  "updates_to_our_terms_of_service": "我们服务条款的更新",
  "email_me_when": "发邮件给我当：",
  "new_classroom": "新教室",
  "student_progress": "学生进度",
  "view_course": "查看课程",
  "view_section": "查看部分",
  "classroom_members_not_found_title": "还没有学生",
  "classroom_members_not_found_desc": "此教室还没有任何学生。",
  "open_topic": "打开主题",
  "choose_game_mode": "选择游戏模式",
  "story": "故事",
  "story_description": "听角色之间的对话并回答问题来测试您的理解。",
  "fill_in_blanks": "填空",
  "fill_in_blanks_description": "您能正确识别缺少的内容吗？",
  "fill_in_the_blanks": "填空",
  "fill_in_the_blanks_description": "您能正确识别缺少的内容吗？",
  "act_it_out": "表演出来",
  "act_it_out_description": "您能选择正确的回应吗？",
  "act_it_out_listening": "表演出来 - 听力",
  "act_it_out_listening_description": "使用您的听力技能选择正确的回应。",
  "act_it_out_speaking": "表演出来 - 口语",
  "act_it_out_speaking_description": "通过说出您的部分练习发音。",
  "act_it_out_listening_speaking": "表演出来 - 听力和口语",
  "act_it_out_listening_speaking_description": "通过说出您的部分练习发音。",
  "select_role": "选择您的角色",
  "select_role_description": "选择您想要扮演的角色。",
  "mute": "静音",
  "unmute": "取消静音",
  "replay": "重新开始",
  "restart": "重新开始",
  "click_to_speak": "点击说话",
  "click_to_stop": "点击停止",
  "listening_indicator": "正在听...",
  "save_recording_to_report": "将录音保存到报告",
  "no_voice_recording_saved": "语音录音未保存",
  "classrooms_not_created": "未创建教室",
  "select_a_classroom": "选择教室",
  "voice_attempt": "语音尝试",
  "upload_variables": "上传变量",
  "next_game": "下一个游戏",
  "roleplay_games": "情景游戏",
  "roleplay_games_description": "点击下面的卡片之一来玩特定游戏",
  "group_courses": "团体课程",
  "select": "选择",
  "classroom_creator_welcome": "教室入门",
  "classroom_creator_welcome_free_trial": "欢迎使用努阿朗30天免费试用！为了帮助您入门，我们已经设置了您的第一个教室。",
  "classroom_creator_add_courses": "添加课程",
  "classroom_creator_add_courses_desc": "选择如何向教室添加课程。",
  "classroom_creator_add_students_email": "邀请学生",
  "classroom_creator_track_progress": "跟踪学生活动",
  "classroom_creator_track_progress_desc": "一旦学生加入教室，点击查看他们在已添加课程上的进度。",
  "forLang_and_learnLang_the_same": "学习语言和使用者语言相同。翻译练习因此被禁用",
  "english": "英语",
  "french": "法语",
  "german": "德语",
  "irish": "爱尔兰语",
  "italian": "意大利语",
  "portuguese": "葡萄牙语",
  "spanish": "西班牙语",
  "close": "关闭",
  "last": "最后",
  "update_avatar": "更新头像",
  "update_avatar_desc": "更新您的个人头像",
  "invite_students": "邀请学生",
  "share_student_link_desc": "分享下面的说明来邀请学生加入。",
  "invite_link_desc": "请通过点击此邀请链接在努阿朗上登录或创建账户：",
  "join_instructions_1": "这将带您到",
  "join_instructions_2": "我为您创建的，您需要点击'加入'",
  "enrollment_key_text": "并输入密钥：",
  "copy_student_instructions": "复制学生说明",
  "or_invite_via": "或通过以下方式邀请",
  "classroom": "教室",
  "invite_email_subject": "邀请加入努阿朗",
  "dear_students": "亲爱的学生们",
  "dashboard": "仪表板",
  "preview_roleplay": "预览情景",
  "roleplay_preview": "预览",
  "roleplay_preview_decription": "预览完整的情景脚本",
  "sort": "排序",
  "sort_by": "排序方式",
  "newest": "最新",
  "alphabetical": "按字母顺序",
  "recently_changed": "最近更改",
  "recently_viewed": "最近查看",
  "oldest": "最早",
  "default": "默认",
  "member": "学生",
  "stop_speaking": "停止说话",
  "agree_to_terms_and_conditions_1": "我同意",
  "nualang_terms": "努阿朗条款",
  "agree_to_terms_and_conditions_2": "，包括接受我们的",
  "privacy_policy": "隐私和数据保护政策",
  "first_classroom_description": "这是一个帮助学生自信地说{{learnLang}}的教室。",
  "upload": "上传",
  "download": "下载",
  "classroom_creator_add_students_email_desc": "点击探索邀请学生到您教室的不同方法。",
  "bot_sign_in_message": "您必须登录才能玩此聊天机器人",
  "course_sign_in_to_access": "登录访问此课程",
  "have_an_account": "有账户吗？",
  "provide_a_little_more_information": "提供更多信息",
  "instructions": "说明",
  "close_preview": "关闭预览",
  "chinese_simplified": "简体中文",
  "chinese_traditional": "繁体中文",
  "check_recognition": "检查语音识别",
  "checking_recognition": "正在检查语音识别...",
  "phrase_recognised": "短语已识别",
  "phrase_not_recognised": "短语未识别",
  "speech_recognition_info": "检查语音识别可以让您确定您的学生在我们的练习中发音此短语是否有困难。",
  "speech_recognition_error_info": "我们将您的短语识别为{{recognisedPhrase}}。我们建议您重新措辞短语和/或添加替代版本。",
  "my_library": "我的图书馆",
  "add_own_exercise_message": "使用您创建的模板创建新的{{exerciseName}}",
  "no_exercises_in_library": "您没有创建{{exerciseName}}。",
  "classroom_invite_feature_disabled_message": "此功能已禁用，因为您的学生将能够自动加入此教室。",
  "skip_navigation": "跳过导航",
  "generate_roleplay": "生成情景",
  "choose_topic_for_roleplay": "为情景选择主题",
  "roleplay_generated": "情景已生成",
  "select_roleplay": "选择情景",
  "chatgpt_roleplay_description": "这是一个关于{{topic}}的情景",
  "check_answer": "检查答案",
  "card": "卡片",
  "banner": "横幅",
  "load_more": "加载更多",
  "bot_input_placeholder": "使用键盘输入消息",
  "bot_input_mobile_placeholder": "输入消息...",
  "audio_only_mode": "听与说",
  "audio_only_tooltip": "切换到仅音频模式",
  "switch_to_text": "切换到文本",
  "switch_to_text_tooltip": "切换回文本模式",
  "audio_only_title": "与{{botName}}对话",
  "audio_only_subtitle": "完全语音对话——没有任何文字。建议佩戴耳机。",
  "audio_only_mode_unavailable_fallback_chat": "此练习需要“听说”模式,但此设备不支持该模式,将改用聊天模式继续。",
  "microphone_ready": "麦克风已就绪",
  "bot_is_speaking": "正在说话...",
  "thinking_indicator": "思考中...",
  "start_conversation": "开始对话",
  "stop_button_label": "停止",
  "stop_bot_message": "停止聊天机器人语音",
  "choose_mode_text_option": "聊天",
  "choose_mode_text_option_desc": "输入或说出你的答案,然后阅读或聆听机器人的回复。",
  "bot_mode_in_progress_icon": "{{mode_name}}对话当前正在进行中",
  "bot_mode_completed_icon": "{{mode_name}}已完成{{counter}}次",
  "bot_modes_completed_icon": "{{mode_name}}已完成{{counter}}次",
  "replay_button_label": "重播",
  "replay_bot_message": "重复聊天机器人消息",
  "you": "你",
  "ready_when_you_are": "准备好后即可开始",
  "bot_speaking_banner": "{{botName}}正在说话",
  "listening_to_you": "正在倾听",
  "bot_thinking_banner": "{{botName}}正在思考",
  "one_moment": "请稍候",
  "listen_first": "先听",
  "tap_when_done": "完成后点击",
  "conversation_complete": "对话已完成",
  "exchanges_label": "交流次数",
  "time_spoken_label": "说话时长",
  "review_your_turns": "查看你的发言",
  "submit_to_teacher": "提交给老师",
  "great_job": "做得好！",
  "or": "或",
  "choose_difficulty_of_roleplay": "为情景选择难度",
  "child": "儿童",
  "game_visibility": "游戏可见性",
  "duplicate_course": "重复课程",
  "amount_must_not_exceed_10": "数量不得超过10",
  "amount_must_be_greater_than_0": "数量必须大于0",
  "voice_pitch": "语音音调",
  "voice_pitch_example": "你好，我的名字是{{name}}",
  "voice_pitch_disabled": "此语音无法调整音调。",
  "voice_pitch_x_low": "非常低",
  "voice_pitch_low": "低",
  "voice_pitch_medium": "中等",
  "voice_pitch_high": "高",
  "voice_pitch_x_high": "非常高",
  "contact_us": "联系我们",
  "contact_us_message": "感谢您使用努阿朗。请在下面发送您的消息，我们会尽快回复您。",
  "expected_phrases": "预期短语",
  "expected_phrases_info": "您期望学生在练习中使用的短语，您希望在学生说话时能被正确识别。例如，如果练习是关于天气的，您可能希望更经常地识别单词'weather'而不是'whether'",
  "add_expected_phrases": "添加预期短语",
  "phrase_length_exceeded_error": "短语不应超过100个字符",
  "whats_new": "新功能",
  "wayside_subscription_message": "您的订阅由Wayside Publishing管理",
  "select_the_correct_answer": "选择正确答案",
  "pronunciation_score": "发音分数",
  "pronunciation_score_explanation": "发音分数基于正确识别的单词数量（{{transcriptCompletenessPercentage}}%）以及它们被识别的清晰度。",
  "add_course": "添加课程",
  "generate_roleplay_existing_script_confirmation": "您确定要替换现有脚本吗？",
  "experimental_feature_desc": "新AI功能 - 我们很想听听您的反馈",
  "generating_roleplay": "正在生成情景",
  "updated": "已更新",
  "exercise_completed": "练习已完成",
  "exercise_not_completed": "练习未完成",
  "view_topic": "查看主题",
  "view_roleplay": "查看情景",
  "view_bot": "查看聊天机器人",
  "student_reports_problem": "学生在练习中报告问题",
  "problem_reported": "已报告问题",
  "remove_course_confirmation": "您确定要移除此课程吗？",
  "classroom_member_limit_reached": "教室已达到学生限制",
  "upload_pdf": "上传PDF",
  "remove_pdf": "移除PDF",
  "classroom_updated": "教室已更新",
  "deleted": "已删除",
  "created": "已创建",
  "moderation_warning": "在您上传的图片中检测到以下类别：",
  "warning": "警告",
  "use_anyways": "仍然使用",
  "view_pdf": "查看故事",
  "schedule_discussion": "安排讨论",
  "video_chat": "视频聊天",
  "video_chat_member": "视频聊天成员",
  "create_meeting": "创建会议",
  "group_assignment": "小组作业",
  "join_group": "加入小组",
  "groups": "小组",
  "group": "小组",
  "welcome": "欢迎",
  "delete_pdf": "删除PDF",
  "delete_pdf_confirmation": "您确定要删除此PDF吗？",
  "course_updated": "课程已更新",
  "overwrite_phrases": "覆盖短语",
  "roleplay_game_in_progress_icon": "情景游戏当前正在进行中",
  "roleplay_game_completed_icon": "情景游戏已完成{{counter}}次",
  "roleplay_games_completed_icon": "情景游戏已完成{{counter}}次",
  "page": "页面",
  "remove_group": "移除小组",
  "create_groups": "创建小组",
  "select_all": "全选",
  "unknown": "未知",
  "add_a_discussion_topic": "添加讨论主题",
  "add_a_discussion_prompt": "添加讨论提示",
  "add_a_url_for_students_to_discuss": "添加供学生讨论的URL",
  "images_that_students_can_use_as_a_background_during_the_call": "学生在通话期间可用作背景的图片",
  "discussion_images": "讨论图片",
  "images_for_students_to_discuss_during_the_call": "学生在通话期间讨论的图片",
  "recording_time": "录制时间",
  "due_date": "截止日期",
  "record_time_limit": "录制时间限制",
  "interculturality": "跨文化性",
  "comprehensibility": "可理解性",
  "function_and_text_type": "功能和文本类型",
  "vocabulary_in_context": "语境中的词汇",
  "Drag_and_drop_image_from_your_computer": "从您的计算机拖放图片",
  "schedule_discussion_options": "文件大小超出",
  "chat_options": "聊天选项",
  "recording_info": "提交信息",
  "discussion_id": "讨论ID",
  "discussion_prompt": "讨论提示",
  "attendees": "参与者",
  "created_discussions": "已创建的讨论",
  "grouped_discussions": "分组讨论",
  "no_recordings_found": "未找到录音",
  "recordings": "录音",
  "scheduled_meetings": "已安排的会议",
  "no_meetings_scheduled": "没有安排会议",
  "discussion_info": "讨论信息",
  "invites": "邀请",
  "invited_members": "受邀学生",
  "minute": "分钟",
  "feedback": "反馈",
  "view": "查看",
  "no_data_found": "未找到数据",
  "no_past_discussions_found": "未找到过去的讨论",
  "no_submissions_found": "未找到提交",
  "background_images": "背景图片",
  "no_scheduled_discussions_found": "未找到已安排的讨论",
  "view_more": "查看更多",
  "past": "过去",
  "submissions": "提交",
  "join_live_game": "加入在线游戏",
  "live_game_medals": "实时游戏奖章",
  "live_game_medals_description": "在实时游戏中获得第1、2或3名，解锁奖章",
  "classroom_has_no_live_game": "教室当前没有在线游戏",
  "speech_recognition_error_info_no_phrase": "我们没有识别您的短语。我们建议您重新措辞短语和/或添加替代版本。",
  "no_conversation_available": "没有可用的对话",
  "no_special_characters": "不能包含特殊字符",
  "required": "必需",
  "enrolment_key_min_chars": "注册密钥必须至少为5个字符",
  "zoom_in": "放大",
  "zoom_out": "缩小",
  "game_created": "游戏已创建",
  "nuala_performance_rating": "努阿拉表现评级",
  "using_nuala_performance": "如果您使用努阿拉表现评级，您将丢失任何手动创建的评分。",
  "are_you_sure_nuala_performance": "您确定要使用努阿拉表现评级吗？",
  "play_live": "在线游戏",
  "play_live_desc": "选择您想在教室中在线游戏的练习。",
  "live_dialog_description": "选择您想在教室中在线游戏的练习。",
  "course_deletion_note": "*注意：删除此课程也将删除此课程中的{{sectionCount}}个部分及其内容",
  "classroom_deletion_note": "*注意：删除此教室也将删除此教室中的{{courseCount}}个课程及其内容",
  "topic_deletion_note": "*注意：删除此主题也将删除此主题中的{{phraseCount}}个短语、{{botCount}}个聊天机器人和{{roleplayCount}}个情景及其内容",
  "section_deletion_note": "*注意：删除此部分也将删除此部分中的{{topicCount}}个主题及其内容",
  "confirmDeletionText": "要确认删除，请在下面的字段中输入'delete'",
  "subscription_status_cancelled": "已取消",
  "subscription_status_active expired": "已过期",
  "subscription_status_active_expired": "已过期",
  "leaderboard": "排行榜",
  "waiting_message": "准备好，游戏即将开始",
  "play_game": "玩游戏",
  "close_game": "关闭游戏",
  "cancel_game": "取消游戏",
  "end_game": "结束游戏",
  "games": "游戏",
  "course_no_sections": "此课程没有部分",
  "topic_no_phrases": "此主题没有短语",
  "next_question": "下一个问题",
  "your_answer": "您的答案",
  "change_answer": "更改答案",
  "final_results": "结果",
  "game_ended": "游戏结束",
  "joined_game": "已加入游戏",
  "equipment_problem_label": "设备问题",
  "equipment_problem_example": "例如：我的扬声器或麦克风无法工作",
  "technical_problem_label": "技术问题",
  "technical_problem_example": "例如：应用程序无法正常工作",
  "content_problem_label": "内容问题",
  "content_problem_example": "例如：我注意到练习内容中有错误",
  "end_question_early": "提前结束问题",
  "discussion_topic": "讨论主题",
  "discussion_link": "讨论链接",
  "scheduled": "已安排",
  "timer_length": "计时器长度",
  "go_back_to_classroom": "返回教室",
  "discussion_created": "讨论已创建",
  "discussion_updated": "讨论已更新",
  "give_feedback": "给予反馈",
  "nualang_live_welcome": "欢迎来到努阿朗在线！",
  "nualang_live_invite": "邀请学生",
  "nualang_live_invite_desc": "点击这里查看学生如何加入游戏。",
  "nualang_live_game_members": "游戏成员",
  "nualang_live_game_members_desc": "点击这里查看谁还没有加入游戏。",
  "nualang_live_start_game": "开始游戏！",
  "nualang_live_settings": "游戏设置",
  "nualang_live_settings_desc": "点击这里查看游戏选项",
  "keyboard_and_word_bank": "键盘和单词库",
  "keyboard_only": "仅键盘",
  "word_bank_only": "仅单词库",
  "answer_options": "答案选项",
  "game_settings": "游戏设置",
  "create_feedback": "创建反馈",
  "first_place": "第一名",
  "second_place": "第二名",
  "third_place": "第三名",
  "final_score": "最终得分",
  "no_discussions_found": "未找到讨论",
  "no_discussions_found_desc": "所有讨论和提交都可以在这里找到",
  "quality_of_interaction": "互动质量",
  "number_of_questions": "问题数量",
  "estimated_game_time": "预计游戏时间",
  "minutes": "分钟",
  "discuss": "讨论",
  "open_live_game": "开启在线游戏",
  "correct_answers": "正确答案",
  "game_has_ended": "此游戏已结束，请等待新的在线游戏。",
  "game_has_canceled": "此游戏已被取消，请等待新的在线游戏。",
  "allow_wordBank": "允许学生在练习中使用单词库",
  "creator_default": "创建者默认",
  "course_default": "课程默认",
  "course_settings_description": "调整此教室学生的学习体验",
  "change_settings": "更改设置",
  "choose_topic_from_pdf_for_roleplay": "基于课程PDF的上下文为情景选择主题",
  "use_context_from_course_pdf": "使用课程PDF的上下文",
  "use_context_from_course_pdf_info": "开启此功能可以基于课程PDF的内容生成情景，如果提示与PDF中的内容相关",
  "feedback_all_info": "向讨论小组中的所有学生提供反馈。您不能同时向学生提供小组和个人反馈。",
  "rubric_info_desc": "查看分析性增长量规，我们AI反馈中使用的标准。",
  "rubric_info": "量规信息",
  "listen_to_story": "听故事",
  "roleplay_no_interactions": "此情景没有互动",
  "number_of_interactions": "互动数量",
  "archive_title_submissions": "归档提交",
  "archive_description_submissions": "您确定要归档提交吗？",
  "archive_title": "归档讨论",
  "archive_description": "您确定要归档此讨论吗？此讨论的学生邀请也将被移除。",
  "discussion_templates": "讨论模板",
  "discussion_templates_desc": "使用我们预定义的讨论模板之一，帮助您为学生创建内容",
  "find_courses": "查找课程",
  "create_your_own": "创建您自己的",
  "community_courses_description": "从图书馆为您的学生找一门课程",
  "create_your_own_description": "为您的学生构建全新的课程",
  "empty_live_dialog_description": "如果您想在教室中在线游戏，请添加课程。",
  "no_classroom_to_join": "您的老师还没有在努阿朗上设置他们的教室。请要求他们这样做，然后重试。",
  "resume": "继续",
  "pause": "暂停",
  "discuss_welcome": "讨论指南",
  "discuss_scheduled_discussions": "已安排的讨论",
  "discuss_scheduled_discussions_desc": "这里您将找到老师创建的已安排讨论。您将能够加入这些讨论并与小组中的其他学生谈论主题。",
  "discuss_refresh_discussions": "刷新讨论",
  "discuss_refresh_discussions_desc": "此按钮允许您刷新以获取最新的讨论数据。",
  "discuss_recorded_discussions": "录制讨论",
  "discuss_recorded_discussions_desc": "在这里您可以找到您录制并提交供老师审查的讨论。一旦给出反馈，您就能够查看。",
  "discuss_grouped_discussions": "分组讨论",
  "discuss_grouped_discussions_desc": "在这里您可以找到您基于主题名称为学生创建的所有讨论。点击进入分组讨论以查看创建了哪些学生小组。",
  "discuss_submissions": "讨论提交",
  "discuss_submissions_desc": "在这里您可以找到学生小组创建的录制讨论提交。您可以查看他们的录音，以及讨论的转录并给予个人或小组反馈。",
  "refresh_discuss": "刷新讨论",
  "nuala_ai": "努阿拉AI",
  "performance_ratings": "表现评级",
  "attended": "已参加",
  "did_not_attend": "未参加",
  "discussion_attendance": "讨论出席",
  "submitted_recordings": "提交的录音",
  "invalid_date": "日期无效",
  "go_to_profile_settings": "前往个人资料设置",
  "not_applicable": "省略",
  "comprehension": "理解",
  "feedback_text": "反馈文本",
  "submit_feedback": "提交反馈",
  "select_students_to_group": "选择所有学生",
  "created_groups": "已创建的小组",
  "feedback_info": "反馈信息",
  "sample_discussion_ideas": "示例讨论想法",
  "image_library": "图片库",
  "upload_video": "上传视频",
  "select_video_desc": "从您的计算机拖放视频",
  "add_video": "添加视频",
  "play_video": "播放视频",
  "video_info": "课程视频",
  "delete_video": "删除视频",
  "delete_video_confirmation": "您确定要删除此视频吗？",
  "view_video": "查看视频",
  "video_options": "视频选项",
  "congratulations": "恭喜！",
  "medal_has_been_added_to_your_profile": "徽章已添加到您的个人资料",
  "pdf_options": "PDF选项",
  "disable_keyboard": "禁用键盘",
  "enable_keyboard": "启用键盘",
  "view_story": "查看故事",
  "view_question": "查看问题",
  "save_library": "保存到图书馆",
  "minimum_two_phrases": "此练习至少需要主题中的两个短语。",
  "roleplay_not_valid": "此练习至少需要一个互动和一个问题。",
  "move_topic": "移动主题",
  "move_section": "移动部分",
  "move_roleplay": "移动情景",
  "duplicate_roleplay": "重复情景",
  "leave_game": "离开游戏",
  "leave_game_confirmation": "您确定要离开此游戏吗？",
  "leave": "离开",
  "explore": "探索",
  "listen": "听",
  "download_template": "下载模板",
  "member_activity": "学生活动",
  "move_phrase": "移动短语",
  "multiple_choice": "单选",
  "record": "录制",
  "nualang_live_help": "如何游戏",
  "nualang_live_help_desc": "点击这里查看如何玩游戏",
  "roleplay-story": "故事",
  "teach_classrooms_desc": "在动态学习环境中管理并与您的学生互动",
  "teach_classrooms_title": "参与您的教室",
  "teach_courses_desc": "设计和构建您的课程以提供完整的学习体验",
  "teach_courses_title": "构建综合课程",
  "teach_roleplays_title": "一种新的情景",
  "teach_roleplays_desc": "使用情景教学让您的学生参与脚本对话，提供动态和沉浸式的语言技能练习方式",
  "teach_bots_title": "聊天机器人创意",
  "teach_bots_desc": "使用聊天机器人教学可以帮助您的学生建立信心和自然的对话风格，就像真实对话一样流畅",
  "learn_bots_title": "聊天机器人创意",
  "learn_bots_desc": "使用聊天机器人学习可以帮助您发展自然而引人入胜的对话风格，就像真实对话一样流畅",
  "learn_roleplays_title": "一种新的情景",
  "learn_roleplays_desc": "使用情景学习让您参与脚本对话，提供动态和沉浸式的语言技能练习方式",
  "learn_classrooms_desc": "加入可以与同学和老师在动态学习环境中互动的教室",
  "learn_classrooms_title": "互动学习空间",
  "learn_courses_desc": "注册旨在为您提供结构化课程和活动的完整学习体验的课程",
  "learn_courses_title": "综合学习路径",
  "video_included": "视频",
  "story_included": "故事",
  "answer_helper_text": "按回车键添加答案。",
  "move_answer": "移动答案",
  "remove_answer": "移除答案",
  "remove_question": "移除问题",
  "supported_file_types": "支持的文件类型：mp4, mov",
  "exercise_description": "听这个短语",
  "translate_description": "尽快翻译短语以获得最多分数！",
  "result_description": "看看您在所有人中的排名！",
  "listening_description": "尽快选择答案以获得最多分数！",
  "roleplay_intro": "听两个角色之间的对话！",
  "topic_no_roleplays": "此主题没有情景。",
  "case_sensitive": "这被标记为区分大小写",
  "required_field": "标有*的字段是必填的",
  "close_drawer": "关闭抽屉",
  "generate_question": "生成问题",
  "generating_question": "正在生成问题",
  "experimental_feature_desc_answer": "'生成问题'按钮是新AI功能 - 我们很想听听您的反馈",
  "question_type": "问题类型",
  "multiple_choice_factual": "单选 - 事实",
  "multiple_choice_inference": "单选 - 推断",
  "vocabulary": "词汇",
  "true_false": "真/假",
  "insert_emoji": "插入表情符号",
  "moderation_reason": "图片因包含以下内容而被阻止：{{moderationReason}}",
  "move_bot": "移动聊天机器人",
  "duplicate_bot": "重复聊天机器人",
  "discuss_description": "讨论是您进行实时互动对话的平台。基于您的提示创建引人入胜的讨论或从建议的主题中选择。观看您的学生实时协作和分享想法。",
  "enable_discuss": "在设置中启用讨论",
  "incomplete_translation": "这个句子还有更多内容！",
  "experimental_feature_desc_phrases": "'生成短语'按钮是新AI功能 - 我们很想听听您的反馈",
  "choose_topic_for_phrases": "您希望短语的主题是什么？",
  "how_many_phrases": "短语数量：{{phraseAmount}}",
  "generate_phrases": "生成短语",
  "generating_phrases": "正在生成短语",
  "duplicate_answer_desc": "问题不能有重复答案",
  "question_language": "为问题和答案选择语言",
  "generate_questions": "生成问题",
  "enable_gen_questions": "启用此功能以生成与情景相关的理解问题。",
  "use_topic_phrases": "使用主题短语",
  "enable_phrase_context": "启用此功能以使用您主题中的短语作为生成情景的上下文。",
  "add_phrase_context": "请在您的主题中添加短语以启用此功能。",
  "enter_phrase_with_alternatives": "输入带有替代项的短语",
  "sentences": "句子",
  "words": "单词",
  "phrase_type": "短语类型",
  "archive_classroom": "归档教室",
  "archive_classroom_confirmation": "您确定要归档此教室吗？",
  "unarchive_classroom": "取消归档教室",
  "unarchive_classroom_confirmation": "您确定要取消归档此教室吗？",
  "confirmArchiveText": "要确认归档，请在下面的字段中输入'archive'",
  "confirmUnarchiveText": "要确认取消归档，请在下面的字段中输入'unarchive'",
  "generate_bot": "生成聊天机器人",
  "generating_bot": "正在生成聊天机器人",
  "choose_topic_for_bot": "您希望此聊天机器人的主题是什么？",
  "use_context_from_topic_phrases": "使用主题短语",
  "generate_bot_existing_script_confirmation": "您确定要替换现有脚本吗？",
  "voice_speed": "语音速度",
  "phrase_to_speak": "要说的短语",
  "voice_speed_extra_slow": "极慢",
  "voice_speed_slow": "慢",
  "voice_speed_medium": "中等",
  "voice_speed_fast": "快",
  "voice_speed_extra_fast": "极快",
  "play_audio": "播放音频",
  "generate_audio": "生成音频",
  "topic_goal": "交际目标",
  "topic_goal_info_text": "您希望学习者在本课结束时能够做什么？",
  "archived_classrooms_title": "没有归档的教室",
  "archived_classrooms_desc": "完成教室后，您可以将其归档。这将为所有学生和协作者归档教室。",
  "bot_created": "聊天机器人已创建",
  "bot_deleted": "聊天机器人已删除",
  "ukrainian": "乌克兰语",
  "arabic": "阿拉伯语",
  "czech": "捷克语",
  "danish": "丹麦语",
  "dutch": "荷兰语",
  "filipino": "菲律宾语",
  "greek": "希腊语",
  "hindi": "印地语",
  "hungarian": "匈牙利语",
  "indonesian": "印度尼西亚语",
  "japanese": "日语",
  "korean": "韩语",
  "malay": "马来语",
  "polish": "波兰语",
  "punjabi": "旁遮普语",
  "romanian": "罗马尼亚语",
  "swahili": "斯瓦希里语",
  "thai": "泰语",
  "turkish": "土耳其语",
  "vietnamese": "越南语",
  "speak_disabled": "说话已禁用",
  "move_message": "移动消息",
  "move_question": "移动问题",
  "topic_goal_placeholder": "例如：我可以询问并回答有关我身份的问题。",
  "download_csv_template": "下载CSV模板",
  "upload_csv": "上传CSV",
  "remove_csv": "移除CSV",
  "single_phrase": "单个短语",
  "list_of_phrases": "短语列表",
  "text_studio": "文本转语音工作室",
  "text_studio_description": "努阿拉在这里帮助您将文本转换为语音，选择一种语言并从我们的语音选择中选择，让您的文本变得生动。",
  "no_phrases_yet": "还没有短语...",
  "access_denied_domain_unverified": "访问被拒绝：域名未验证",
  "file_name": "文件名",
  "download_audio": "下载音频",
  "no_answer": "没有答案",
  "left_group": "已离开小组",
  "view_feedback": "查看反馈",
  "no_feedback": "您还没有给这个学生反馈",
  "app_search_placeholder": "搜索社区内容",
  "delete_phrases": "删除短语",
  "delete_phrases_confirmation": "您确定要删除选中的短语吗？",
  "share_audio": "如果您不想与努阿朗分享您的音频，请取消勾选此框。分享音频将帮助我们诊断问题。",
  "edit_phrase": "编辑短语",
  "share_screenshot": "如果您想与努阿朗分享您的屏幕截图，请勾选此框。分享屏幕截图将帮助我们诊断问题。",
  "screenshot_captured": "已捕获屏幕截图：",
  "classroom_creator_play_live_game": "玩努阿朗在线",
  "classroom_creator_play_live_game_desc": "努阿朗在线提供可定制的游戏，为学生创造动态而引人入胜的环境，让他们测试技能并相互竞争以赢得令人垂涎的努阿拉徽章。",
  "search_error": "搜索时出现错误，请重试",
  "create_feedback_error": "创建反馈时出现错误，请重试",
  "get_recs_error": "获取录音时出现错误",
  "get_image_error": "获取图片时出现错误",
  "update_discussion_error": "更新讨论时出现错误，请重试",
  "invite_users_error": "邀请用户时出现错误，请重试",
  "create_image_error": "上传图片时出现错误，请重试",
  "grade_conversation_error": "评分对话时出现错误，请重试",
  "get_transcript_error": "获取转录时出现错误，请重试",
  "get_subs_error": "获取提交时出现错误，请重试",
  "delete_picture_confirmation": "您确定要删除此图片吗？",
  "inappropriate_language_detected": "检测到不当语言",
  "schedule_discussion_error": "安排讨论时出现错误，请重试",
  "heritage_speaker": "读/写",
  "unmark_as_heritage_speaker": "禁用读/写模式",
  "mark_as_heritage_speaker": "启用读/写模式",
  "heritage_speaker_desc": "通过在适当时禁用听力和口语来专注于阅读和写作。专为传统学习者设计。",
  "heritage_speaker_point_1": "单词库将被禁用",
  "heritage_speaker_point_2": "听力和发音将在适当时被禁用。",
  "freely_changed": "这可以随时自由更改。",
  "mark_as_challenge_student": "启用挑战模式",
  "unmark_as_challenge_student": "禁用挑战模式",
  "mark_as_challenge_bot": "标记为挑战模式",
  "unmark_as_challenge_bot": "取消标记为挑战模式",
  "challenge_student": "挑战模式",
  "challenge_student_desc": "解锁提示扩展回应和正式学术语言的聊天机器人。专为传统学习者设计。",
  "challenge_bot": "挑战模式",
  "challenge_bot_desc": "此聊天机器人仅对在学生选项卡中启用挑战模式的学生可见。专为传统学习者设计，提供正式的学术提示。",
  "rewatch_tutorial": "重新观看教程",
  "heritage_speaker_progress": "标记为'读/写'的学生将调整学习体验以更注重阅读和写作。",
  "generate_transcript": "生成转录",
  "suggested_images": "建议图片",
  "word_near_correct": "这个单词是正确的，但位置错误",
  "partially_correct": "部分正确",
  "tag_info": "标签有助于组织和分类内容，使查找和分组相关材料更容易。使用标签改善内容的可发现性并简化您的工作流程。",
  "assignments": "作业",
  "assign_exercises": "分配练习",
  "assign_exercises_desc": "从您精选的内容库中选择活动并只需几次点击即可分配给学生。观看他们参与旨在强化学习、练习技能和加深理解的练习。",
  "assign_discuss": "分配讨论",
  "assign_discuss_desc": "讨论是您进行实时互动对话的平台。基于您的提示创建引人入胜的讨论或从建议的主题中选择。观看您的学生实时协作和分享想法。",
  "archive_discussions": "归档讨论",
  "archive_submissions": "归档提交",
  "assignment": "作业",
  "create_assignment": "创建作业",
  "no_assignments": "没有作业",
  "assignments_description": "作业是让您的学生参与互动内容的好方法。创建作业以强化学习、练习技能和加深理解。",
  "no_assignments_desc": "此教室中还没有作业。",
  "select_classroom": "选择教室",
  "assignment_title": "作业标题",
  "assignment_description": "作业描述",
  "select_members": "选择学生",
  "schedule_assignment": "安排作业",
  "assign_date": "可用从",
  "add_exercise": "添加练习",
  "add_exercises": "添加练习",
  "assign_exercises_description": "从您的图书馆中选择练习分配给学生",
  "due_in": "截止于",
  "due_tomorrow": "明天到期",
  "student_edited_transcript": "学生在录制后手动编辑了此转录。",
  "member_updated": "学生已更新",
  "delete_assignment": "删除作业",
  "delete_assignment_confirmation": "您确定要删除此作业吗？",
  "assignment_deleted": "作业已删除",
  "assignment_created": "作业已创建",
  "assignees_created": "受分配者已创建",
  "classroom_creator_subscription_expired": "创建者的订阅已到期。",
  "return_to_classrooms": "返回教室",
  "creator_not_subscribed_upgrade_title": "订阅已到期",
  "creator_not_subscribed_upgrade": "您的订阅已到期。请升级计划以继续以下功能：",
  "creator_not_subscribed_upgrade_description": "学生访问教室活动。",
  "creator_not_subscribed_upgrade_description2": "创建努阿朗在线游戏的能力",
  "creator_not_subscribed_upgrade_description3": "学生加入教室的能力。",
  "due_today": "今天到期",
  "update_assignment": "更新作业",
  "refresh_assignments": "刷新作业",
  "report_type": "类型",
  "go_back_to_assignments": "返回作业",
  "available_today": "今天可用",
  "available_tomorrow": "明天可用",
  "available_in": "可用于",
  "not_assigned": "未分配",
  "assigned": "已分配",
  "view_assignment": "查看作业",
  "no_assignments_description": "当前没有创建作业。",
  "no_shared_courses": "所选教室之间没有共享课程。",
  "view_submissions": "查看提交",
  "archive": "归档",
  "generated_phrases": "您确定要将以下生成的短语添加到列表中吗？这些短语将被附加，不会替换任何现有短语。",
  "everyone": "所有人",
  "discussions": "讨论",
  "duplicate_course_confirmation": "这将制作您可以编辑的课程副本。您不会获得原始课程的更新或更改。",
  "duplication": "允许其他人重复此课程。",
  "invalid_email_format": "邮箱格式无效",
  "email_domain_mismatch_error": "邮箱必须来自您的域名（{{domain}}）。",
  "generic_email_domain_error": "通用邮箱域名错误",
  "duplicate_disabled_tooltip": "此课程已被创建者禁用重复。",
  "collaborators_only": "仅协作者",
  "assign_to": "分配给",
  "all_students": "所有学生",
  "default_assignment_title": "新教室作业",
  "default_assignment_instructions": "请在截止日期前完成以下任务。",
  "due": "到期",
  "hide_course": "隐藏课程",
  "show_course": "显示课程",
  "hello": "你好",
  "dynamic_response": "动态回应",
  "dynamic_response_desc": "允许此教室中的聊天机器人基于学生输入生成由AI驱动的自定义回复。",
  "ai_chatbot_message_info": "此聊天机器人消息是使用AI生成的。",
  "ai_chatbot_message_generating_info": "此聊天机器人消息正在使用AI生成。",
  "language_correction": "语言纠正",
  "correction_original": "原文",
  "correction_suggested": "建议",
  "language_corrections_to_review": "需要复习的语言纠正",
  "dynamic_responses_info": "启用此功能允许聊天机器人使用AI根据学生所说的内容生成个性化回应。虽然这可以支持更引人入胜的学习，但回应是自动生成的，可能会有所不同。所有AI使用都遵循明确、可信的标准，以确保安全、负责任和可问责的学习。",
  "paste_your_csv_data": "将您的CSV数据粘贴到这里",
  "user_level_settings": "用户级设置",
  "chatbot_dynamic_responses": "Chatbot - Dynamic Responses",
  "chatbot_dynamic_responses_desc": "If dynamic response is turned on, the Chatbots will actively listen and adapt, prompting for more detail, clearer phrasing, or realistic answers, instead of just moving to the next scripted prompt.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "以下转录需要您的审查。",
  "challenge_mode": "挑战模式",
  "student_misuse_reported": "已报告学生滥用",
  "student_acts_inappropriately": "学生在聊天机器人练习中行为不当",
  "ai_chatbot_error_response": "抱歉，我的回复出错了。请重试！",
  "no_members_tooltip": "无法执行此操作，因为此教室中没有学生或课程。",
  "overdue": "逾期",
  "due_next": "下次到期",
  "active": "活跃",
  "archived": "已归档",
  "past_due": "已过期",
  "available_from": "可用从",
  "roleplay-fill-in-the-blanks": "情景填空",
  "roleplay-act-it-out": "情景表演",
  "roleplay-act-it-out-listening": "情景表演听力",
  "roleplay-act-it-out-speaking": "情景表演口语",
  "roleplay-act-it-out-listening-speaking": "情景表演听力和口语",
  "generate_discussion": "生成讨论",
  "generating_discussion": "正在生成讨论",
  "discuss_prompt_language": "为讨论提示选择语言",
  "level": "级别",
  "grouped_discussion": "分组讨论",
  "not_present": "未出席讨论",
  "view_recording": "查看录音",
  "generate_feedback": "生成反馈",
  "generate_feedback_for_all": "为所有人生成反馈",
  "performance_rating": "表现评级",
  "feedback_submitted": "反馈已提交",
  "group_not_submitted": "小组还没有提交录音",
  "this_classroom_is_archived": "此教室已归档",
  "submission_graded": "提交已评分",
  "view_submission": "查看提交",
  "show_more": "显示更多",
  "show_less": "显示更少",
  "submit_feedback_confirmation": "您已审查了所有生成的反馈并准备提交给学生吗？",
  "submit_feedback_scroll": "在提交给学生之前审查所有反馈",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "课程主题",
  "discussion_topic_helper": "选择相关主题以帮助生成讨论。",
  "no_groups_created_yet": "还没有创建小组",
  "select_students_from_the_list": "从左侧列表中选择学生创建小组",
  "drop_members_here": "将学生拖放到这里创建小组",
  "drag_a_student_here": "将学生拖到这里创建小组",
  "new_group": "新小组",
  "cannot_edit_discussion": "无法编辑有现有提交的讨论",
  "generating_feedback": "正在生成反馈",
  "conversations_graded_success": "反馈已生成",
  "below_level": "低于水平",
  "at_level": "符合水平",
  "above_level": "高于水平",
  "ai_performance_assessment": "AI表现评估",
  "performance_chip_tooltip": "基于AI分析，指示学生表现与预期熟练度范围的比较。",
  "performance_chip_note": "仅对教师可见，旨在支持教学审查。",
  "progress": "进度",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "select_the_correct_phrase": "选择此定义的正确短语",
  "chinese": "中文",
  "custom_feedback_placeholder": "可选：添加额外说明以聚焦反馈内容（例如：准确性、复杂度或目标结构的使用）。",
  "generate_feedback_view_the": "查看",
  "generate_feedback_rubric_name": "分析成长评分标准",
  "generate_feedback_rubric_desc": "我们AI反馈中使用的评估标准。",
  "late_submission": "迟交",
  "days_late_one": "迟交{{count}}天",
  "days_late_other": "迟交{{count}}天",
  "generate_definitions": "生成定义",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "短语列表",
  "no_phrase_lists": "没有短语列表",
  "all_phrase_lists": "所有短语列表",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "生成定义时出现问题。请重试。",
  "saving_defintions_error": "保存定义时出现问题。请重试。",
  "auto_generate_definitions": "生成定义",
  "generating_definitions": "正在生成定义",
  "definitions": "定义",
  "view_phrase_list": "查看短语列表",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "复制到",
  "transfer": "复制",
  "create_phrase_list_from_selection": "创建新短语列表",
  "no_other_phrase_lists": "没有其他短语列表",
  "add_row": "添加行",
  "problem_updating": "更新时出现问题",
  "exercise_settings": "练习设置",
  "excercise_voice": "练习声音",
  "excercise_voice_desc": "选择将在此短语列表的练习中使用的声音。",
  "excercise_visibility": "练习可见性",
  "keyboard": "键盘",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "欢迎来到读写练习",
  "read_write_exercise_definition": "定义",
  "read_write_exercise_definition_desc": "阅读此处显示的定义",
  "read_write_exercise_options": "输入短语",
  "read_write_exercise_options_desc": "在文本框中输入正确的短语",
  "read_the_definition": "阅读定义",
  "type_the_correct_phrase": "输入正确的短语",
  "read_write": "读写",
  "meaning_read_write": "含义 - 读写",
  "meaning_read_write_exercise_desc": "阅读定义并输入正确的短语。",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "创建聊天机器人",
  "find_chatbot": "查找聊天机器人",
  "find_chatbots": "查找聊天机器人",
  "add_chatbot": "添加聊天机器人",
  "add_chatbots": "添加聊天机器人",
  "template": "模板",
  "chatbot_name": "聊天机器人名称",
  "create_scenario": "创建情景",
  "find_scenario": "查找情景",
  "find_scenarios": "查找情景",
  "scenario_name": "情景名称",
  "scenarios_added": "情景已添加到主题",
  "chatbots_added": "聊天机器人已添加到主题",
  "add_scenarios": "添加情景",
  "achievements": "成就",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "在<1>社区</1>标签页中查找其他老师创建的主题。",
  "chatbot_title": "聊天机器人",
  "open_ended": "开放式",
  "open_ended_desc": "让你的学生用自己的话回答。",
  "quiz": "测验",
  "quiz_desc": "引导学生回答一系列问题。",
  "picture_quiz": "图片测验",
  "picture_quiz_desc": "根据图片提问。",
  "emoji_quiz": "表情符号测验",
  "emoji_quiz_desc": "根据表情符号猜答案。",
  "quiz_style_templates": "测验式模板",
  "no_scenarios_found": "未找到情景",
  "no_chatbots_found": "未找到聊天机器人",
  "use_voice": "使用语音",
  "internal_view_provider_marks": "内部视图 · 提供商评分可见",
  "legacy": "旧版",
  "scan_to_open_the_classroom": "扫描以打开教室",
  "classroom_link": "教室链接",
  "copy": "复制",
  "tell_students_to": "告诉学生",
  "invite_step_sign_in": "登录他们的账户。",
  "invite_step_scan": "扫描二维码，或打开教室。",
  "invite_step_tap_join": "点击{{button}}。",
  "select_exercise_phrases_intro": "勾选您想要使用的短语列表。您可以混合来自不同课程的列表。",
  "select_exercise_scenarios_intro": "选择一个情景，与全班实时进行。",
  "source_type_phrase_lists": "短语列表",
  "source_type_scenarios": "情景",
  "clear_all": "全部清除",
  "n_of_m_lists_selected": "已选择{{n}}/{{m}}个列表",
  "n_phrase_lists": "{{count}}个短语列表",
  "n_phrases": "{{count}}个短语",
  "has_definitions": "有定义",
  "n_scenarios": "{{count}}个情景",
  "n_messages": "{{count}}条消息",
  "n_interactions": "{{count}}次互动",
  "lists_and_phrases_selected": "{{lists}}个列表 · {{phrases}}个短语",
  "no_lists_selected": "未选择列表",
  "no_scenario_selected": "未选择情景",
  "scenario_selected": "已选择情景",
  "number_of_messages": "消息数量",
  "max_phrases_label": "最多",
  "max_phrases_all": "全部{{count}}",
  "estimated_game_time_hint": "{{questions}}个问题，每题{{seconds}}秒，外加各轮之间的反馈。",
  "n_minutes": "{{count}}分钟",
  "live_game_title": "{{exercise}} · {{count}}个短语列表",
  "phrases_from": "短语来自",
  "source_card_meta": "{{topic}} · {{count}}个短语",
  "n_more": "更多",
  "waiting_for_students": "等待学生加入。",
  "how_students_answer": "学生答题方式",
  "answer_keyboard_and_word_bank": "键盘和单词库",
  "answer_keyboard_and_word_bank_hint": "学生打字输入，单词块作为备选帮助。",
  "answer_keyboard_only": "仅键盘",
  "answer_keyboard_only_hint": "最难 — 学生输入完整答案。",
  "answer_word_bank_only": "仅单词库",
  "answer_word_bank_only_hint": "最简单 — 学生点击单词填入。",
  "time_per_question": "每题时间",
  "all_n_phrases": "全部{{count}}个短语",
  "includes_one_from_each_list": "每个所选列表中至少会包含一个短语。",
  "az": "字母顺序",
  "clear_filters": "清除筛选",
  "search_sections_and_topics": "搜索单元和主题",
  "clear_search": "清除搜索",
  "x_of_y": "{{shown}} / {{total}}",
  "outline_filter_count": "{{sections}}中有{{topics}}",
  "topic_count_one": "{{count}} 个主题",
  "topic_count_other": "{{count}} 个主题",
  "section_count_one": "{{count}} 个单元",
  "section_count_other": "{{count}} 个单元",
  "no_sections_or_topics_match": "没有匹配的单元或主题",
  "try_different_keyword_or_difficulty": "请尝试其他关键词或难度。",
  "nothing_matches_keyword_at_difficulty": "在 {{difficulty}} 难度下没有与“{{keyword}}”匹配的内容。请尝试其他关键词或难度。",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "session_feedback": "你的反馈",
  "session_feedback_preparing": "正在准备你的反馈…",
  "session_feedback_unavailable": "你的反馈暂时无法查看。",
  "suggested_level": "建议水平",
  "session_report": "对话反馈",
  "view_full_report": "查看完整反馈",
  "rating_approaching": "接近",
  "rating_meets": "达到",
  "rating_exceeds": "超出",
  "area_of_strength": "优势",
  "area_for_growth": "提升方向",
  "rating_not_yet": "尚未达到",
  "session_report_short_interaction": "互动",
  "session_report_short_vocabulary": "词汇",
  "session_report_short_function": "功能",
  "session_report_strength": "优势",
  "session_report_growth": "提升",
  "ai_generated_report": "AI 生成的反馈",
  "ai_generated_report_tooltip": "仅根据本次会话由 AI 生成。建议水平和评分仅为估计，并非最终定级。",
  "session_report_new": "新",
  "chatbot_mode_name": "聊天机器人 - {{mode}}",
  "chatbot_message_count": "{{count}} 条消息",
  "chatbot_message_count_other": "{{count}} 条消息",
  "attempt_count": "{{count}} 次作答",
  "attempt_count_one": "{{count}} 次作答",
  "attempt_count_other": "{{count}} 次作答",
  "of_total_correct": "/ {{total}} 正确",
  "attempts_to_review": "需要复习的作答",
  "attempts_not_shown": "未显示的作答：{{items, list}}",
  "count_correct": "{{count}} 正确",
  "count_incorrect": "{{count}} 错误",
  "count_skipped": "{{count}} 跳过",
  "count_partially_correct": "{{count}} 部分正确",
  "view_all_count": "查看全部 {{count}} 个",
  "view_attempt": "查看作答",
  "scenario_description_default": "这是一个帮助学生自信地说{{learnLang}}的情景。"
}
